module.exports = "/images/5.jpg?4fcb0257f55ea1a5a763bfd0ea492e32";